import React from 'react'

import { Row, Col } from '_zari/core'
import { IdGen } from 'utils'

import * as FormGroups from './formGroups'
import * as Tables from './tables'

const commonReducer = (state, action) => {
  switch (action.type) {
    case 'agregar': {
      const newState = [
        ...state,
        {
          ...action.payload,
          _idFila: IdGen.newId()
        }
      ]
      return newState
    }

    case 'actualizar': {
      const newState = state.map(val => {
        if (val._idFila === action.payload._idFila) {
          val = {
            ...val,
            ...action.payload
          }
        }
        return val
      })
      return newState
    }

    case 'setFechaReqDesdeNecesidad': {
      const { fechaNecesidad } = action.payload || {}
      if (!fechaNecesidad) return state

      return state.map(val => {
        const updates = {}
        if (!val.fechaRequerimiento) updates.fechaRequerimiento = fechaNecesidad
        if (!val.fechaNecesidad) updates.fechaNecesidad = fechaNecesidad
        if (Object.keys(updates).length === 0) return val
        return { ...val, ...updates }
      })
    }

    case 'eliminar':
      return state.filter(val => val._idFila !== action.payload._idFila)

    default:
      return state
  }
}

const DetallesSection = ({ detallesRef, editarData, fechaNecesidad }) => {
  const [detalles, detallesDispatcher] = React.useReducer(commonReducer, editarData.detalles, inputArr => {
    if (inputArr) {
      return inputArr.map(x => {
        return {
          ...x,
          _idFila: IdGen.newId()
        }
      })
    }
    return []
  })

  React.useEffect(() => {
    detallesRef.current.getData = () => {
      return detalles
    }
  }, [detallesRef, detalles])

  React.useEffect(() => {
    if (!fechaNecesidad) return

    detallesDispatcher({
      type: 'setFechaReqDesdeNecesidad',
      payload: { fechaNecesidad }
    })
  }, [fechaNecesidad])

  const dispatchConDefaults = React.useCallback(
    action => {
      if (action?.type === 'agregar') {
        const payload = action.payload || {}
        detallesDispatcher({
          ...action,
          payload: {
            ...payload,
            fechaRequerimiento: payload.fechaRequerimiento || fechaNecesidad || '',
            fechaNecesidad: payload.fechaNecesidad || fechaNecesidad || ''
          }
        })
        return
      }
      detallesDispatcher(action)
    },
    [fechaNecesidad]
  )

  return (
    <>
      <Tables.DetallesTable detalles={detalles} dispatch={dispatchConDefaults} />
      <Row style={{ marginBottom: '3.5rem' }}>
        <Col md={12}>
          <FormGroups.ProductoFormGroup dispatch={dispatchConDefaults} autoFocus={detalles.length === 0} />
        </Col>
      </Row>
    </>
  )
}

export default React.memo(DetallesSection)
